import { gql } from "lib/apolloClient";
import { aiFragment } from "./AITutorChatFragments";

export const createAITutorMessageMutation = gql`
  mutation createAITutorMessage($input: CreateAiMessageInput!) {
    ai {
      createAiMessage(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;

export const createBulkAiMessagesMutation = gql`
  mutation createBulkAiMessages($input: CreateBulkAiMessagesInput!) {
    ai {
      createBulkAiMessages(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;

export const resetAITutorConversationMutation = gql`
  mutation resetAIConversation($input: ResetAiConversationInput!) {
    ai {
      resetAiConversation(input: $input) {
        isSuccess
        warning
        responseArray {
          id
          entityType
          messages {
            totalCount
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                ...aiMessageItem
              }
            }
          }
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;

export const updateAITutorMessageMutation = gql`
  mutation updateAITutorMessage($input: UpdateAiMessageInput!) {
    ai {
      updateAiMessage(input: $input) {
        isSuccess
        response {
          conversation {
            id
            messages {
              totalCount
              pageInfo {
                hasNextPage
                endCursor
              }
              edges {
                node {
                  ...aiMessageItem
                }
              }
            }
          }
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;

export const createAITutorConversationMutation = gql`
  mutation createAITutorConversation($input: CreateAiConversationInput!) {
    ai {
      createAiConversation(input: $input) {
        isSuccess
        response {
          id
          entityType
          entitySubType
          metadata
        }
      }
    }
  }
`;

export const updateAIMessageMutation = gql`
  mutation updateAiMessage($input: UpdateAiMessageInput!) {
    ai {
      updateAiMessage(input: $input) {
        isSuccess
        response {
          ...aiMessageItem
        }
      }
    }
  }
  ${aiFragment.aiMessage}
`;
